<template>
<div class="contents_855">
  <header-bar active="wash-request-currents"></header-bar>

  <h1 class="title2">{{ $t('washRequestCurrents.title') }}</h1>

  <div class="contents_box">
    <div v-for="wreq in getItems">
      <h2 class="title3">{{ $t('washRequestCurrents.requestNumber') }}{{wreq.dispNum}}
        <span v-if="wreq.request_type === '2'" class="wreq_week">{{ $t('washRequestCurrents.weeklyFixed') }}</span>
      </h2>
      <table class="form_tab form_line_top">
        <template v-if="!isBagDeliveryRequest(wreq)">
          <tr>
            <th>
              <p class="item2">{{ $t('washRequestCurrents.pickupDateTime') }}</p>
            </th>
            <td>
              <p v-if="wreq.sched_pickup_dt_from" class="line_box col2">
                {{wreq.sched_pickup_dt_from | dtFormat($t('dateTimeFormat.shortDateWithWeekday'))}}
                <br>
                {{wreq.sched_pickup_dt_from | dtFormat($t('dateTimeFormat.time'))}}
                〜
                {{wreq.sched_pickup_dt | dtFormat($t('dateTimeFormat.time'))}}
              </p>
              <p v-else class="line_box col2">
                {{wreq.sched_pickup_dt | dtFormat($t('dateTimeFormat.shortDateTimeWithWeekday'))}}
              </p>
              <p class="line_box col3">
                <button class="btn1 btn_change radius4"
                        :disabled="!wreq.canChangePickupDt"
                        @click="changePickupDt(wreq)">
                  {{wreq.pickupChangeBtText}}
                </button>
                <button class="btn1 btn_change radius4"
                        :disabled="!wreq.canCancel"
                        @click="cancelWashRequest(wreq)">
                  {{ $t('washRequestCurrents.pickupChange') }}
                </button>
              </p>
            </td>
          </tr>
          <tr>
            <th class="form_line_l">
              <p class="item2">{{ $t('washRequestCurrents.deliveryDateTime') }}</p>
            </th>
            <td class="form_line_r">
              <span v-if="wreq.pdSameTime">
                <span class="font_orange">{{ $t('washRequest.willDeliverOnNextPickup') }}</span>
              </span>
              <span v-else>
                <p v-if="wreq.sched_delivery_dt_from" class="line_box col2">
                  {{wreq.sched_delivery_dt_from | dtFormat($t('dateTimeFormat.shortDateWithWeekday'))}}
                  <br>
                  {{wreq.sched_delivery_dt_from | dtFormat($t('dateTimeFormat.time'))}}
                  〜
                  {{wreq.sched_delivery_dt | dtFormat($t('dateTimeFormat.time'))}}
                </p>
                <p v-else class="line_box col2">
                  {{wreq.sched_delivery_dt | dtFormat($t('dateTimeFormat.shortDateTimeWithWeekday'))}}
                </p>
                <p class="line_box col3">
                  <button
                    class="btn1 btn_change radius4"
                    :disabled="!wreq.canChangeDeliveryDt"
                    @click="changeDeliveryDt(wreq)"
                  >
                    {{wreq.deliveryChangeBtText}}
                  </button>
                </p>
              </span>
            </td>
          </tr>
          <tr>
            <th>
              <p class="item2">{{ $t('washRequestCurrents.details') }}</p>
            </th>
            <td>
              <p class="line_box col2">
                {{wreq.size}}／{{wreq.count}}{{ $t('washRequest.unit') }}
              </p>
              <p class="line_box col3" v-if="!isOnetimePlanRequest(wreq)">
                <button class="btn1 btn_change radius4"
                        :disabled="!wreq.canChangeWashRequestCount"
                        @click="changeCount(wreq)">
                  {{ $t('washRequestCurrents.bagCountChange') }}
                </button>
              </p>
            </td>
          </tr>
          <tr v-if="!isOnetimePlanRequest(wreq)">
            <th>
              <p class="item2">{{ $t('washRequestCurrents.deliveryBoxPin') }}</p>
            </th>
            <td>
              <p class="line_box col2 delivery-box-pin-value">
                {{wreq.delivery_box_pw}}
              </p>
              <p class="line_box col3">
                <button class="btn1 btn_change radius4"
                        :disabled="!wreq.canChangeDeliveryBoxPw"
                        @click="changeDeliveryBoxPw(wreq)">
                  {{ $t('washRequest.change') }}
                </button>
              </p>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th class="form_line_l">
              <p class="item2">{{ $t('washRequestCurrents.deliveryDateTime') }}</p>
            </th>
            <td class="form_line_r">
              <span>
                <p class="line_box col2">
                  {{wreq.sched_delivery_dt | dtFormat($t('dateTimeFormat.shortDateTimeWithWeekday'))}}
                </p>
                <p class="line_box col3">
                  <button
                    class="btn1 btn_change radius4"
                    :disabled="!wreq.canChangeDeliveryDt"
                    @click="changeDeliveryDt(wreq)"
                  >
                    {{wreq.deliveryChangeBtText}}
                  </button>
                </p>
              </span>
            </td>
          </tr>
          <tr>
            <th>
              <p class="item2">{{ $t('washRequestCurrents.details') }}</p>
            </th>
            <td>
              <span class="bag-delivery-text mr4">{{ $t('washRequestCurrents.bagDelivery') }}</span>／{{wreq.count}}{{ $t('washRequest.unit') }}
            </td>
          </tr>
        </template>
      </table>
    </div>
    <pager :itemCount="itemCount" :itemsPerPage="itemsPerPage" :pageRange="pageRange" @click="updatePage"></pager>

    <table class="form_tab" v-if="!noWashReqs">
      <tr>
        <th class="form_line_l"></th>
        <td class="form_line_r">
          <wash-request-notice-messages mongon-type="B">
          </wash-request-notice-messages>
        </td>
      </tr>
    </table>

    <div v-if="noWashReqs">
      <p class="mypage_notes mg30 mg_bt30 font_orange">
        {{ $t('washRequestCurrents.noCurrentRequests') }}
      </p>
      <p class="submit_bx1">
        <router-link :to="{name:'wash-request'}" class="glnavi_btn_on">
          {{ $t('washRequestCurrents.makeRequest') }}
        </router-link>
      </p>
    </div>

  </div>
</div>
</template>

<script>
import washRequestMixin from '@/mixin/washRequestMixin'
import Pager from '@/components/lib/Pager';
import userApi from '@/api/user'
import { isOnetimeTypeAlphaAvailable } from '@/utils/areaInfoUtil'
import { isOnetimePlan, isPickupDeliverySameTime } from '@/utils/planUtils';
import { setScheduleFromDatetime } from '@/utils/washRequestUtils';

export default {
  name: 'wash-request-currents',
  components: {
    Pager
  },
  data() {
    return {
      washReqs: [],
      noWashReqs: false,
      itemCount: 0,
      itemsPerPage: 20,
      pageRange: 3,
      currentPage: 1,
    }
  },
  computed: {
    getItems: function() {
      let current = this.currentPage * this.itemsPerPage;
      let start = current - this.itemsPerPage;
      return this.washReqs.slice(start, current);
    },
  },
  async mounted() {
    const token = this.$store.getters['localStorage/serverToken']
    if (!token) {
      this.$router.push({name: 'login'})
    }
    const onetimeTypeAlphaAvailable = await isOnetimeTypeAlphaAvailable(this.$store)
    const maxWreqCount = 60
    const [mst, { data: washRequestsData }] = await Promise.all([
      window.master.$promise,
      userApi.getMyWashRequests(),
    ])
    this.washReqs = this.getWashRequestCurrents(washRequestsData)
    this.washReqs = this.washReqs.map(e => {
      e.size = mst.lovsMap['size'][mst.planMap[e.plan_id].size].val + this.$t('size')
      e.pdSameTime = isPickupDeliverySameTime(e.plan_id)
      if (isOnetimePlan(e.plan_id)) {
        e.size = this.$t('master.planPart.tx') + '（45L）'

        if (onetimeTypeAlphaAvailable) {
          setScheduleFromDatetime(e)
        }
      }

      return e
    }).slice(0, maxWreqCount)
    this.itemCount = this.washReqs.length
    this.noWashReqs = this.washReqs.length === 0
  },
  mixins: [washRequestMixin],
  methods: {
    updatePage(page){
      this.currentPage = page;
    },
    changePickupDt(wreq) {
      this.$router.push({
        name: 'wash-request-change',
        params: {
          id: wreq.id
        }
      })
    },
    changeDeliveryDt(wreq) {
      this.$router.push({
        name: 'wash-request-change',
        params: {
          id: wreq.id
        }
      })
    },
    cancelWashRequest(wreq) {
      this.$router.push({
        name: 'wash-request-cancel',
        params: {
          id: wreq.id
        }
      })
    },
    changeCount(wreq) {
      this.$router.push({
        name: 'wash-request-bag-count-change',
        params: {
          id: wreq.id
        },
      })
    },
    changeDeliveryBoxPw(wreq) {
      this.$router.push({
        name: 'wash-request-delivery-box-change',
        params: {
          id: wreq.id
        },
      })
    },
    isBagDeliveryRequest(wreq) {
      return wreq.is_bag_delivery
    },
    isOnetimePlanRequest(wreq) {
      return isOnetimePlan(wreq.plan_id)
    },
  }
}
</script>

<style lang="scss" scoped>
.form_tab {
  .col2 {
    width: 184px;
  }
}

.delivery-box-pin-value {
  min-height: 1.5em;
}

h2{
  position: relative;
}

.wreq_week{
  color: #fff;
  background-color: #ff7b45;
  padding: 2px 10px;
  position: absolute;
  right: 2%;
  top: 22%;
  font-size: 12px;
}

.bag-delivery-text {
  color: #fff;
  background-color: #78a65a;
  padding: 2px 4px;
  border-radius: 4px;
}
</style>
